module.exports = __webpack_public_path__ + "img/1_025.35ff027c.jpg";